import { opexBudgetIntervalMeta } from './opexBudgets';
import type { OpexGroupMonthSummary } from './purchaseBudget';

export function formatPurchaseBudgetUsd(n: number): string {
  return n.toLocaleString('en-US', { style: 'currency', currency: 'USD', maximumFractionDigits: 2 });
}

export function formatOpexBudgetedDisplay(summary: Pick<OpexGroupMonthSummary, 'budgetUnset' | 'budgetedUsd' | 'interval'>): string {
  if (summary.budgetUnset || summary.budgetedUsd == null) return 'Not set';
  return `${formatPurchaseBudgetUsd(summary.budgetedUsd)} ${opexBudgetIntervalMeta(summary.interval).suffix}`;
}
